var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"rounded-circle card-link go-back",attrs:{"size":"sm"},on:{"click":_vm.goBack}},[_c('b-icon-arrow-left')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }